/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAirplaneTopView: {
  name: 'airplane-top-view';
  data: string;
} = {
  name: 'airplane-top-view',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.646.646a.5.5 0 0 1 .708 0l2 2A.5.5 0 0 1 10.5 3v1.849l3.916 5.874A.5.5 0 0 1 14.5 11v3a.5.5 0 0 1-.8.4L10.5 12v3a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-3l-3.2 2.4a.5.5 0 0 1-.8-.4v-3a.5.5 0 0 1 .084-.277L5.5 4.849V3a.5.5 0 0 1 .146-.354l2-2ZM9.5 10.994V14.5h-3V3.207l1.5-1.5 1.5 1.5v7.787Zm1-.244 3 2.25v-1.849l-3-4.5v4.099Zm-5 0V6.651l-3 4.5V13l3-2.25Z" fill="currentColor"/></svg>`,
};
